export default {
  create: 'Crear',
  review: 'Revisar',
  approve: 'Aprobar',
  approved: 'Aprobado',
  creator: 'Creador',
  submitter: 'Remitente',
  reviewer: 'Revisor',
  approver: 'Aprobador',
  create_new_payment: 'Crear nuevo pago',
  new_payment: 'Nuevo pago',
  edit_payment: 'Editar pago',
  payment_details: 'Detalles del pago',
  create_payment_disbursement: 'Crear desembolso',
  create_small_value_payment: 'Crear pago de bajo valor',
  create_large_value_payment: 'Crear pago de alto valor',
  large_payment_min_amount: 'El monto del pago no puede ser inferior a 200,000,001',
  large_payment_max_amount: 'El monto del pago no puede exceder 300,000,000',
  standard_payment_min_amount: 'El monto no puede ser inferior a {amount}',
  single_disbursement: 'Desembolso único',
  small_value_payment: 'Desembolso de bajo valor',
  batch_disbursement: 'Desembolsos por lotes de bajo valor',
  single_payment_details: 'Detalles del pago único',
  recipient_account_number: 'Número de cuenta del beneficiario',
  batch_payment_details: 'Detalles del pago por lotes',
  excel_worksheet_template_excel: 'Plantilla de hoja de Excel',
  download_template: 'Descargar plantilla',
  single_payout_payment_type: 'Tipo de pago',
  business_detail: 'Detalles del negocio',
  new_batch_small_disbursement: 'Nuevos desembolsos por lotes de bajo valor',
  first_things_first: 'Lo primero es lo primero',
  submit_batch_ease: 'EPasos para enviar pagos por lotes',
  step_1_title: 'Descargue la última plantilla:',
  step_1_content: 'Asegúrese de estar utilizando el archivo de plantilla de pagos masivos más reciente; puede descargarlo directamente desde el botón de arriba.',
  step_2_title: 'Complete su información:',
  step_2_content: 'Complete los detalles del pago en la plantilla, incluyendo la información del beneficiario, el monto, entre otros.',
  step_3_title: 'Suba y envíe',
  step_3_content: 'Suba la plantilla completada para iniciar el proceso de pagos masivos.',
  step_4_title: 'Descargar los resultados: ',
  step_4_content: 'Una vez finalizado el procesamiento, puede descargar el informe de resultados haciendo clic en la lista de "Historial de cargas por lote" en la barra lateral.'
}
